import GroupOutlined from '@mui/icons-material/GroupOutlined';
import { SidebarItem } from '@traton/devportal-env-kit-app';
import { usePortalgroupsPermissions } from '../../hooks/usePortalgroupsPermissions';

export const PortalgroupsSidebarItem = () => {
  const { canRead, loading } = usePortalgroupsPermissions();

  if (loading || !canRead) return null;

  return (
    <SidebarItem
      icon={GroupOutlined}
      to="/groups"
      text="Groups"
      pluginId="portalgroups"
    />
  );
};
